
<div id="browser-editor-holder">
  <div id="editor-handle">Course Editor</div>
  <div id="exporter-holder"></div>
  <div id="browser-course-editor">
    <button id="resetBtn" data-icon="fas fa-trash">CLR</button>
    <button id="localeBtn">Locale</button>
    <button id="submitBtn">Submit</button>
    <select id="howToSubmit" name="howToSubmit">
      <option>Submit</option>
      <option selected="selected">Direct</option>
    </select>
    <select id="operation" name="operation">
      <option selected="selected">Replace</option>
      <option>Before</option>
      <option>After</option>
    </select>
    <div id="input-holder">
      <textarea id="ymlInput" contenteditable="true"></textarea>
    </div>
  </div>
</div>
